import { Drawer as MuiDrawer, styled } from '@mui/material';

export const Drawer = styled(MuiDrawer)(
  ({ width }) => `
  & .MuiDrawer-paperAnchorLeft {
    position: absolute;
    width: ${width ?? '100%'} ;
    overflow: hidden;
    padding-bottom:40px;
  }
`,
);
